import { YesObject } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import AutocompleteMultiselectionField from '../../../FilterFields/components/Field/AutocompleteMultiselectionField'
import AutocompleteUniselectionField from '../../../FilterFields/components/Field/AutocompleteUniselectionField/AutocompleteUniselectionField'
import { ArrayFieldValue, FieldValuesValue } from '../../../FilterFields/types'

type RelationSelectionFieldProps = {
  objectclassUuid: string
  isUniselection: boolean
  selectedOptions: YesObject[]
  onChangeValues: (values: ArrayFieldValue) => void
  disabled?: boolean
  inputRef?: React.Ref<HTMLInputElement>
  label?: string
  renderInPortal?: boolean
}

const toUniselectionOptions = (options: YesObject[]): ArrayFieldValue =>
  options.map(({ uuid, des }) => ({ uuid, des }))

const toMultiselectionOptions = (options: YesObject[]) =>
  options.map(({ uuid, des }) => ({
    id: uuid,
    value: des
  }))

const RelationSelectionField = ({
  objectclassUuid,
  isUniselection,
  selectedOptions,
  disabled,
  inputRef,
  label,
  renderInPortal,
  onChangeValues
}: RelationSelectionFieldProps) => {
  const uniselectionOptions = useMemo(
    () => toUniselectionOptions(selectedOptions),
    [selectedOptions]
  )

  const multiselectionOptions = useMemo(
    () => toMultiselectionOptions(selectedOptions),
    [selectedOptions]
  )

  const handleMultiselectionChange = (values: FieldValuesValue) => {
    if (!onChangeValues || typeof values === 'string') return
    onChangeValues(values)
  }

  if (isUniselection) {
    return (
      <AutocompleteUniselectionField
        objectclassUuid={objectclassUuid}
        selectedOptions={uniselectionOptions}
        onChangeValues={onChangeValues}
        inputRef={inputRef}
        disabled={disabled}
        aria-label={label}
        renderInPortal={renderInPortal}
      />
    )
  }

  return (
    <AutocompleteMultiselectionField
      objectclassUuid={objectclassUuid}
      selectedOptions={multiselectionOptions}
      onChangeValues={handleMultiselectionChange}
      inputRef={inputRef}
      disabled={disabled}
      aria-label={label}
      renderInPortal={renderInPortal}
    />
  )
}

export default RelationSelectionField
